import MaterialUiCheckBox from '@material-ui/core/Checkbox';
import React, { forwardRef, useEffect } from 'react';

import styles from './Table.scss';

interface Props {
  indeterminate?: boolean;
  name: string;
  icon: React.ReactElement;
  checkedIcon: React.ReactElement;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useCombinedRefs = (...refs: any[]): React.MutableRefObject<any> => {
  const targetRef = React.useRef();

  React.useEffect(() => {
    refs.forEach((ref) => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
};

const IndeterminateCheckbox = forwardRef<HTMLInputElement, Props>(
  ({ indeterminate, ...rest }, ref: React.Ref<HTMLInputElement>) => {
    const defaultRef = React.useRef(null);
    const combinedRef = useCombinedRefs(ref, defaultRef);

    useEffect(() => {
      if (combinedRef?.current) {
        combinedRef.current.indeterminate = indeterminate ?? false;
      }
    }, [combinedRef, indeterminate]);

    return (
      <MaterialUiCheckBox
        classes={{ root: styles.checkbox, checked: styles.checked }}
        ref={combinedRef}
        {...rest}
      />
    );
  }
);

export default IndeterminateCheckbox;
